import React, { useEffect, useState, useRef } from 'react';
import { STATISTICS } from '../data';

export const Stats: React.FC = () => {
  return (
    <section className="py-12 bg-slate-950 border-y border-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {STATISTICS.map((stat) => (
            <div key={stat.id} className="flex flex-col items-center justify-center text-center group">
              <span className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-b from-white to-slate-400 mb-2 group-hover:scale-110 transition-transform duration-300">
                {stat.value}
              </span>
              <span className="text-sm text-mc-blue font-bold uppercase tracking-wider">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};